import { Skeleton } from './Skeleton';

export type BigStatProps = {
  title: string;
  value?: string;
  unit?: string;
  loading?: boolean;
};

export function BigStat({ title, value, unit, loading }: BigStatProps) {
  return (
    <div className="grid gap-1 text-white 3xl:gap-2">
      {loading ? (
        <>
          <Skeleton className="h-6 w-16" />
          <Skeleton className=" h-10 w-32" />
        </>
      ) : (
        <>
          <dt className="text-xl md:text-2xl">{title}</dt>
          <dd className="text-3xl font-bold md:text-5xl">
            {value}{' '}
            {unit && <span className="text-2xl font-normal">{unit}</span>}
          </dd>
        </>
      )}
    </div>
  );
}
